export const de_locale = {
  labelReset: "Zurücksetzen",
  labelDefault: "Standard",
  labelAuto: "Auto",
  labelNone: "Keine",
  labelEdit: "Bearbeiten",
  labelClose: "Schließen",
  labelSizeExtraSmall: "Extra klein",
  labelSizeSmall: "Klein",
  labelSizeMediumSmall: "Mittel-klein",
  labelSizeMedium: "Mittel",
  labelSizeMediumLarge: "Mittel-groß",
  labelSizeLarge: "Groß",
  labelSizeExtraLarge: "Extra groß",
  labelButtonRevert: "Zurückkehren",
  labelButtonCancel: "Abbrechen",
  labelButtonUndo: "Rückgängig",
  labelButtonRedo: "Wiederholen",
  labelButtonExport: "Speichern",
  cropLabel: "Zuschneiden",
  cropLabelButtonRecenter: "Zentrieren",
  cropLabelButtonRotateLeft: "Nach links drehen",
  cropLabelButtonRotateRight: "Nach rechts drehen",
  cropLabelButtonFlipHorizontal: "Horizontal spiegeln",
  cropLabelButtonFlipVertical: "Vertikal spiegeln",
  cropLabelSelectPreset: "Zuschneideform",
  cropLabelCropBoundary: "Begrenzung",
  cropLabelCropBoundaryEdge: "Bildkante",
  cropLabelCropBoundaryNone: "Keine",
  cropLabelTabRotation: "Drehung",
  cropLabelTabZoom: "Zoom",
  statusLabelButtonClose: "Schließen",
  stickerLabel: "Sticker",
  shapeLabelButtonSelectSticker: "Ein Bild auswählen",
  shapeTitleButtonFlipHorizontal: "Horizontal spiegeln",
  shapeTitleButtonFlipVertical: "Vertikal spiegeln",
  shapeTitleButtonRemove: "Entfernen",
  shapeTitleButtonDuplicate: "Duplizieren",
  shapeTitleButtonMoveToFront: "Nach vorne bewegen",
  shapeLabelInputText: "Text bearbeiten",
  shapeLabelInputCancel: "Abbrechen",
  shapeLabelInputConfirm: "Bestätigen",
  shapeLabelStrokeNone: "Keine Umrandung",
  shapeLabelFontStyleNormal: "Normal",
  shapeLabelFontStyleBold: "Fett",
  shapeLabelFontStyleItalic: "Kursiv",
  shapeLabelFontStyleItalicBold: "Kursiv Fett",
  shapeTitleBackgroundColor: "Füllfarbe",
  shapeTitleFontFamily: "Schriftart",
  shapeTitleFontSize: "Schriftgröße",
  shapeTitleFontStyle: "Schriftstil",
  shapeTitleLineHeight: "Zeilenhöhe",
  shapeTitleLineStart: "Start",
  shapeTitleLineEnd: "Ende",
  shapeTitleStrokeWidth: "Linienstärke",
  shapeTitleStrokeColor: "Linienfarbe",
  shapeTitleLineDecorationBar: "Balken",
  shapeTitleLineDecorationCircle: "Kreis",
  shapeTitleLineDecorationSquare: "Quadrat",
  shapeTitleLineDecorationArrow: "Pfeil",
  shapeTitleLineDecorationCircleSolid: "Kreis gefüllt",
  shapeTitleLineDecorationSquareSolid: "Quadrat gefüllt",
  shapeTitleLineDecorationArrowSolid: "Pfeil gefüllt",
  shapeTitleColorTransparent: "Transparent",
  shapeTitleColorWhite: "Weiß",
  shapeTitleColorSilver: "Silber",
  shapeTitleColorGray: "Grau",
  shapeTitleColorBlack: "Schwarz",
  shapeTitleColorNavy: "Marineblau",
  shapeTitleColorBlue: "Blau",
  shapeTitleColorAqua: "Aqua",
  shapeTitleColorTeal: "Petrol",
  shapeTitleColorOlive: "Olivgrün",
  shapeTitleColorGreen: "Grün",
  shapeTitleColorYellow: "Gelb",
  shapeTitleColorOrange: "Orange",
  shapeTitleColorRed: "Rot",
  shapeTitleColorMaroon: "Weinrot",
  shapeTitleColorFuchsia: "Fuchsia",
  shapeTitleColorPurple: "Lila",
  shapeTitleTextColor: "Textfarbe",
  shapeTitleTextAlign: "Textausrichtung",
  shapeTitleTextAlignLeft: "Linksbündiger Text",
  shapeTitleTextAlignCenter: "Zentrierter Text",
  shapeTitleTextAlignRight: "Rechtsbündiger Text",
  shapeLabelToolSharpie: "Filzstift",
  shapeLabelToolEraser: "Radiergummi",
  shapeLabelToolRectangle: "Rechteck",
  shapeLabelToolEllipse: "Ellipse",
  shapeLabelToolArrow: "Pfeil",
  shapeLabelToolLine: "Linie",
  shapeLabelToolText: "Text",
  shapeLabelToolPreset: "Vorlage",
  statusLabelProcessImage: (state) => {
    if (!state || !state.task)
      return undefined;
    if (state.task === 'store') {
      if (state.error)
        return 'Fehler beim Hochladen des Bildes';
      return 'Bild hochladen';
    }
    if (state.error)
      return 'Fehler bei der Verarbeitung des Bildes';
    return 'Bild wird verarbeitet…';
  },
  statusLabelLoadImage: (state) => {
    if (!state || !state.task)
      return 'Warten auf Bild';
    if (state.error)
      return 'Fehler beim Laden des Bildes';
    if (state.task === 'blob-to-bitmap')
      return 'Vorschau wird erstellt…';
    return 'Bild wird geladen…';
  }
}
